import { Badge, Box, Collapse, Flex, Heading, IconButton, Table, Tbody, Td, Text, Th, Thead,  Tr, useDisclosure } from "@chakra-ui/react";
import { WithAuth } from "@/hoc";
import { useEffect, useState } from "react";
import { BackButton } from "@/components";
import { formatCurrency, formatFinalNumbers, formattedCreditCardStatus, formattedCreditCardStatusColor } from "@/utils";
import { useCreditCard } from "@/hooks/useCreditCard";
import { format } from "date-fns";
import ConfigCreditCard from "../configurar-cartao";
import { CreditCardInvoice } from "../fatura-cartao";
import { useNavigate, useParams } from "react-router-dom";
import { ChevronDownIcon, ChevronUpIcon } from "@chakra-ui/icons";
import { PageHeading, Pills, Tooltip } from "barte-design-system";

const InvoicePage = () => {
    const { 
      getInitialCreditCardInvoicesData, 
      creditCardInvoice
    } = useCreditCard();
    const currentBalance = creditCardInvoice.totalAmount;
    const { isOpen, onClose } = useDisclosure();
    const { id } = useParams();
    const [closeCards, setCloseCards] = useState<number[]>([]);
    useEffect(() => {
      getInitialCreditCardInvoicesData(id);
    }, [])
    const navigate = useNavigate();

    const PRIORITY = ["OVERDUE", "CLOSED", "OPEN", "PAID"];

    const status = creditCardInvoice?.cardInvoices?.reduce(
      (acc, curr) => PRIORITY.indexOf(curr.status) < PRIORITY.indexOf(acc) ? curr.status : acc,
      "PAID"
    );

    return (
        <>
        <ConfigCreditCard 
          isOpen={isOpen}
          onClose={onClose}
        />
        <Flex 
            w="100%" 
            justify="center" 
            align="center"
            flexDir="column"
            gap="1rem"
        >
            <PageHeading
              title="Detalhes da fatura"
              onBack={() => navigate(-1)}
            />
            <Flex 
                flexDir="column"
                width="100%"
                gap="1rem"
                py="4"
                maxW="1280px"
            >
             
                <CreditCardInvoice
                  availableLimit={0}
                  usedPercentage={0}
                  currentBalance={currentBalance}
                  customHeight="100px"
                  dueDate={creditCardInvoice?.cardInvoices?.at(0)?.dueDate}
                  nextClosingDate={creditCardInvoice?.cardInvoices?.at(0)?.endDate}
                  status={status}
                />
                {/**TABELA INVOICE */}
                <Box borderWidth="1px" borderRadius="md" overflow="hidden" bg="white">
                    <Table variant="simple">
                        <Thead bg="gray.50">
                            <Tr
                                display="flex"
                                justifyContent="space-between"
                                bgColor="white"
                                borderBottom="1px solid"
                                borderBottomColor="gray.50"
                            >
                                <Th 
                                    border="none"
                                >
                                    Lançamento
                                </Th>
                                <Th border="none">
                                    Operação
                                </Th>
                                <Th
                                    border="none"
                                >
                                    Status
                                </Th>
                                <Th 
                                    border="none"
                                    isNumeric
                                >
                                    Valor
                                </Th>
                            </Tr>
                        </Thead>

                        {creditCardInvoice?.cardInvoices?.filter(ci => ci.transactions.length > 0)?.map((invoice) => {
                            const isClose = closeCards.includes(invoice.id);
                            return (
                                <Tbody key={invoice.id}>
                                <Tr
                                    bg="gray.10"
                                    cursor="pointer"
                                    onClick={() =>{
                                        const updatedCloseCards = [...closeCards]
                                        if (!isClose) {
                                            updatedCloseCards.push(invoice.id)
                                            setCloseCards(updatedCloseCards);
                                        } else {
                                            const index = updatedCloseCards.findIndex(ucc => ucc === invoice.id);
                                            updatedCloseCards.splice(index, 1);
                                            setCloseCards(updatedCloseCards);
                                        }
                                    }}
                                >
                                    <Td colSpan={4}>
                                        <Flex align="center" justify="space-between">
                                            <Flex
                                                gap="2"
                                            >
                                                <Text fontWeight="semibold">
                                                    final{" "}
                                                    <Text as="span" fontWeight="bold">
                                                        {formatFinalNumbers(invoice.virtualCard.maskedPan)}
                                                    </Text>
                                                </Text>
                                                <Text>
                                                    {invoice.virtualCard.cardName.toLocaleUpperCase()}
                                                </Text>
                                            </Flex>
                                            <IconButton
                                                aria-label="expand"
                                                icon={isClose ? <ChevronDownIcon /> : <ChevronUpIcon />}
                                                size="sm"
                                                variant="ghost"
                                            />
                                        </Flex>
                                    </Td>
                                </Tr>
                                {/* Collapse para mostrar transações */}
                                <Tr p={0}>
                                    <Td colSpan={4} p={0} border="none">
                                        <Collapse in={!isClose} animateOpacity>
                                        {invoice.transactions.length > 0 ? (
                                        [...invoice.transactions]
                                            .sort(
                                            (a, b) =>
                                                new Date(b.transactionDate).getTime() -
                                                new Date(a.transactionDate).getTime()
                                            )
                                            .map((tx) => (
                                            <Flex
                                                key={tx.id}
                                                px={4}
                                                py={3}
                                                borderBottom="1px solid"
                                                borderColor="gray.100"
                                                align="center"
                                                justify="space-between"
                                            >
                                                <Flex>
                                                    <Text fontSize="sm">
                                                        {format(new Date(tx.transactionDate), "dd/MM/yy HH:mm:ss")}
                                                    </Text>
                                                </Flex>
                                                <Flex
                                                    maxW="220px"
                                                    w="100%"
                                                >
                                                    <Tooltip
                                                        label={tx.description}
                                                    >
                                                        <Text 
                                                            fontWeight="medium"
                                                            textOverflow="ellipsis"
                                                        >
                                                            {tx.description}
                                                        </Text>
                                                    </Tooltip>
                                                </Flex>
                                                <Flex
                                                    maxW="100px"
                                                    w="100%"
                                                >
                                                    <Pills label={formattedCreditCardStatus(tx.status)} variant="light" state={formattedCreditCardStatusColor(tx.status)} size="base" />
                                                </Flex>
                                                <Flex
                                                    maxW="100px"
                                                    w="100%"
                                                >
                                                    <Text 
                                                        fontWeight="bold"
                                                        textOverflow="ellipsis"
                                                        textAlign="right"
                                                        w="100%"
                                                    >
                                                        {formatCurrency({ value: tx.amount })}
                                                    </Text>
                                                </Flex>
                                            </Flex>
                                            ))
                                        ) : (
                                            <Box px={4} py={3}>
                                                <Text fontSize="sm" color="gray.500">
                                                    Nenhuma transação neste período.
                                                </Text>
                                            </Box>
                                        )}
                                        </Collapse>
                                    </Td>
                                </Tr>
                                </Tbody>
                            );
                        })}
                    </Table>
                </Box>
            </Flex>
        </Flex>
        </>
    );
};

export default WithAuth(InvoicePage);
